import { SelectedMarkerV2 } from 'components/site/general/singleSelect/SelectedMarkerV2';
import styled from 'styled-components/macro';

interface Props {
    markerIds: string[];
}

export const MultiMarkerSelection = (props: Props) => {
    return (
        <S_MultiMarkerSelection>
            {props.markerIds.map((markerId) => (
                <SelectedMarkerV2 key={markerId} markerId={markerId} />
            ))}
        </S_MultiMarkerSelection>
    );
};

export const S_MultiMarkerSelection = styled.div``;
